export default "__VITE_ASSET__pzKdqIhe__"